export default () => {
	document.querySelectorAll('.menu .menu__item').forEach((menuLink) => {
		let location = document.location.pathname
		let link = menuLink.getAttribute('href')
		if (location == link) {
			menuLink.classList.add('menu__item--active')
		}
	})
}
